import createPersistedState from "vuex-persistedstate"
export const studioStore = {
  namespaced: true,
  state: {
    storeStudios: [],
    selectedStudio: null,
    reservationTypes: null,
    selectedEmployee: null,
  },
  getters: {
    getSelectedStudioId(state) {
      return state.selectedStudio ? state.selectedStudio._id : null
    },
    getStudios(state) {
      return state.storeStudios.filter((e) => e.code)
    },

    getSelectedEmployee(state) {
      return state.selectedEmployee
    },
    getReservationStatus(state) {
      return (
        !!state.selectedStudio &&
        !!state.selectedStudio._id &&
        state.reservationTypes.some((i) => i.studio.toString() === state.selectedStudio._id.toString())
      )
    },
  },
  mutations: {
    setSelectedEmployee(state, employee) {
      state.selectedEmployee = employee ? JSON.parse(JSON.stringify(employee)) : null
    },
    setReservationTypes(state, data) {
      state.reservationTypes = JSON.parse(JSON.stringify(data))
    },
    // This mutation is used to set the studios in the store
    setStudios(state, data) {
      state.storeStudios = JSON.parse(JSON.stringify(data))
    },
    setSelectedStudio(state, data) {
      state.selectedStudio = JSON.parse(JSON.stringify(data))
    },
  },
  actions: {
    setReservationTypes({ commit }, data) {
      commit("setReservationTypes", data)
    },
    setSelectedStudio({ commit }, data) {
      commit("setSelectedStudio", data)
    },
    setStudios({ commit }, data) {
      commit("setStudios", data)
    },
    selectEmployee({ commit }, employee) {
      commit("setSelectedEmployee", employee)
    },
  },
}
